import { Dataset, DatasetControl } from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import { SubsetControlMethodActionApiRequestData } from '../../types/types';
import { getDatasetControlMethodActionApiRequestData } from './getDatasetControlMethodActionApiRequestData';

export const getSubsetControlMethodActionApiRequestData = (
  dataset: Dataset,
  masterDataset: Dataset,
  control: DatasetControl,
  token: string | null,
  masterExpandedRow: any,
  currentRow: any,
  rowsToUse: any[],
  cachedQueryId?: string | null
): SubsetControlMethodActionApiRequestData => {
  const requestData = getDatasetControlMethodActionApiRequestData(
    dataset,
    control,
    token,
    currentRow,
    rowsToUse,
    cachedQueryId
  );

  const masterDataKey = getDataKey(masterDataset);

  return {
    ...requestData,
    master: {
      id: masterExpandedRow?.[masterDataKey],
      idItem: masterDataset.idItem,
    },
  };
};
